import { AuthService, AuthResponseData } from './../service/auth.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs';
import { UserService } from '../service/user.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit {
  isLoading = false;
  error = null;
  testSite = false;
  password1 = '';
  password2 = '';
  submitted = false;
  level = 'starter';
  checkRedirect = false;
  showSignup = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.level = params['level'];
    });

    setTimeout(() => {
      this.userService.userData.subscribe((userData: any) => {
        // console.log(userData);
        if (userData && !this.checkRedirect) {
          this.checkRedirect = true;
          if (this.authService.redirect) {
            this.router.navigateByUrl(this.authService.redirect);
          } else {
            this.router.navigate(['/dashboard']);
          }
        } else {
          this.checkRedirect = true;
        }
      });
    }, 1000);

    // are we logged in?
    this.testSite = environment.testSite;
    const user = this.authService.user.getValue();
    this.isLoading = this.authService.fetching.getValue();
    // try this..
    setTimeout(() => {
      this.isLoading = false;
    }, 1000);
  }
  onSubmit(form: NgForm) {
    this.submitted = true;
    if (!form.valid) {
      this.submitted = false;
      return;
    }
    const email = form.value.email;
    const password = this.password1;
    const name = form.value.name;

    this.isLoading = true;

    this.authService.register(email, password, name).subscribe(
      (resData) => {
        form.reset();
        this.isLoading = false;
        this.submitted = false;
        this.router.navigate(['/dashboard'], {
          queryParams: { level: this.level },
        });
      },
      (errorMessage) => {
        this.error = errorMessage;
        this.isLoading = false;
        this.submitted = false;
      }
    );
  }

  checkPassword(password: string, check: string) {
    switch (check) {
      case 'upper':
        return /[A-Z]/.test(password);
        break;
      case 'lower':
        return /[a-z]/.test(password);
        break;
      case 'num':
        return /[0-9]/.test(password);
        break;
      case 'special':
        return /[$@$!%*?&]/.test(password);
        break;
    }
    return false;
  }
}
